// extracted by mini-css-extract-plugin
module.exports = {"button__play":"VideoButton-module--button__play--do8Mf"};